<template>

    <div class="bg-white px-8  flex flex-col py-6 lg:mx-20 font-sans bg-gray-200">


        <div class="flex flex-col w-full items-center mb-4">
            <img alt="school logo" src="../../images/gciosa.png" class="h-20 w-20 mb-1">
            <p class="text-xl capitalize font-bold font-serif text-center">Register</p>
        </div>




        <div class="mb-6">

            <div class="-mx-3 md:flex mb-6 mx-auto"  style="justify-content: center; align-items: flex-end;">
                
                <div class="w-48 h-48 mb-4 mx-auto">
                    <div class="group w-48 h-48 rounded-full overflow-hidden shadow-inner text-center bg-purple table cursor-pointer">
                        <img :src="imageUrl" alt="lovely avatar" class="object-fill object-center w-48 h-48 visible group-hover:hidden" />
                    </div>
                </div>
                <file-selector v-model="selected_image" v-on:file_url="showImage"></file-selector>
            </div>

            <div class="-mx-3 md:flex mb-6">

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-title">
                        Title <span class="text-red-600">*</span>
                    </label>
                    <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline capitalize
                    rounded py-3 px-4 mb-3 border-gray-400" id="grid-title" type="text" placeholder="Ms" v-model="reqbody.title">
                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-first-name">
                        First Name <span class="text-red-600">*</span>
                    </label>
                    <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline capitalize
                    rounded py-3 px-4 mb-3 border-gray-400" id="grid-first-name" type="text"
                           placeholder="Adekunle" v-model="reqbody.first_name">
                </div>
            </div>


            <div class="-mx-3 md:flex mb-6">

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-last-name">
                        Last Name <span class="text-red-600">*</span>
                    </label>
                    <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline capitalize
                    rounded py-3 px-4 mb-3 border-gray-400" id="grid-last-name" type="text"
                           placeholder="Ciroma" v-model="reqbody.last_name">

                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-other-name">
                        Other/Maiden Name
                    </label>
                    <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline capitalize
                    rounded py-3 px-4 mb-3 border-gray-400" id="grid-other-name" type="text"
                           placeholder="Chukwujekwu" v-model="reqbody.other_name">
                </div>
            </div>


            <div class="-mx-3 md:flex mb-6">

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-email">
                        Email <span class="text-red-600">*</span>
                    </label>
                    <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400" id="grid-email" type="text"
                           placeholder="adekunle@ciroma.com" v-model="reqbody.email">

                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-occupation">
                        Occupation <span class="text-red-600">*</span>
                    </label>
                    <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline capitalize
                    rounded py-3 px-4 mb-3 border-gray-400" id="grid-occupation" type="text" placeholder="Teacher"
                           v-model="reqbody.occupation">
                </div>
            </div>

            <div class="-mx-3 md:flex mb-6">

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="password">
                        Password <span class="text-red-600">*</span>
                    </label>
                    <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400" id="password" type="password"
                           placeholder="*****" v-model="reqbody.password">

                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="password2">
                        confirm Password <span class="text-red-600">*</span>
                    </label>
                    <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400" id="password2" type="password"
                           placeholder="*****" v-model="reqbody.password_confirmation">
                </div>
            </div>

            <div class="-mx-3 md:flex mb-6">

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-phone">
                        Phone number <span class="text-red-600">*</span>
                    </label>
                    <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400" id="grid-phone" type="text" placeholder="020998875439" v-model="reqbody.phone_number">

                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-address">
                        Address <span class="text-red-600">*</span>
                    </label>
                    <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline capitalize
                    rounded py-3 px-4 mb-3 border-gray-400" id="grid-address" type="text" placeholder="9, Adekunle street, Yaba"
                           v-model="reqbody.home_address">
                </div>
            </div>

            <div class="-mx-3 md:flex mb-2">
                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-gender">
                        Gender <span class="text-red-600">*</span>
                    </label>
                    <div class="relative">
                        <select class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400" id="grid-gender" v-model="reqbody.gender">

                            <option value="female">Female</option>
                            <option value="male">Male</option>
                        </select>
                    </div>
                </div>

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-bday">
                        Birthday <span class="text-red-600">*</span>
                    </label>
                    <div class="relative">
                        <input class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-2 px-4 mb-3 border-gray-400" type="date"
                               name="date" id="grid-bday" placeholder="YYYY-MM-DD" v-model="reqbody.birthday">
                    </div>
                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-marital-status">
                        Marital Status <span class="text-red-600">*</span>
                    </label>
                    <div class="relative">
                        <select class="block w-full bg-gray-200 text-grey-darker border outline-none focus:shadow-outline
                    rounded py-3 px-4 mb-3 border-gray-400" id="grid-marital-status" v-model="reqbody.marital_status">

                            <option value="Single">Single</option>
                            <option value="Married">Married</option>
                            <option value="Divorced">Divorced</option>
                            <option value="Widowed">Widowed</option>
                        </select>
                    </div>
                </div>
            </div>


        </div>

        <div class="flex-wrap">
            <div class="flex mx-auto mb-3" v-if="loading">
                        <!-- <img alt="school logo" class="object-contain h-10 w-20" src="../images/loading.gif"> -->
                <vue-loaders
                    name="ball-spin-fade-loader" color="#2a4365" class="mx-auto my-4" scale="1"></vue-loaders>
            </div>
            <button v-else @click="register"
                    class="flex mx-auto bg-blue-700 hover:bg-blue-900 text-white uppercase tracking-wider text-sm
                    font-semibold px-10 py-3 mb-3 rounded">
                Create an account
            </button>

            <p class="flex mx-auto items-center justify-center">
                <a class="text-blue-700 text-center text-base" href="/">Already have an account? Login</a>
            </p>

        </div>

<!--        <a class="text-blue-700 text-center text-sm" href="/login">Already have an account? Login</a>-->



    </div>


</template>

<style scoped>

</style>

<script>
    import Axios from 'axios';
    import FileSelector from "../admin/FileSelector";
    // import router from '../../routes';
    export default {
        name: 'register',
        components: {FileSelector},
        data: function(){
            return {
                reqbody: {user_type: 'user'},
                errors: [],
                loading: false,
                imageUrl: 'https://via.placeholder.com/150',
                // image64: null,
                selected_image: null,
            }
        },
        methods: {

            getBase64 : function(file){
                return new Promise((resolve, reject)=> {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);

                    reader.onerror = error => reject(error);
                })


            },


            showImage: function(image_url) {
                // console.log(image_url);
                // this.image_url = image_url;


                this.getBase64(this.selected_image).then(data => {

                    // console.log(data);
                    // this.image_string = data;
                    // this.images.push({image_url: image_url, image_string: data});
                    this.imageUrl = image_url;
                    // this.image64 = data;
                    this.reqbody.image = data;

                    this.selected_image = null;
                    // console.log(this.imageURLs);


                });
            },

            register: function(e){

                let fields = ['title', 'first_name', 'last_name', 'email', 'occupation', 'password', 'password_confirmation',
                    'phone_number', 'home_address', 'gender', 'birthday', 'marital_status', 'image'];
                this.errors = [];
                fields.forEach((item) => {

                    if(!(item in this.reqbody)){
                        this.errors.push(item.replace("_", " "));
                    }

                });

                if(this.errors.length < 1  && this.reqbody.password.length >= 7 && (this.reqbody.password === this.reqbody.password_confirmation)){
                    this.loading = true;
                    // console.log(this.reqbody);
                    Axios.post('/api/register',
                        this.reqbody,
                        {headers: {'Content-Type': 'application/json'}}
                        ).then(response => {
                        // console.log(response.data);
                        if(response.data.status){
                            const authToken = (response.data.token.original.access_token);
                            localStorage.setItem('token', authToken);
                            this.loading = false;

                            this.$swal({
                                position: 'top-end',
                                toast: true,
                                icon: 'success',
                                title: `Welcome, ${response.data.user.first_name}`,
                                showConfirmButton: false,
                                timer: 1500
                            });
                            this.$router.push('/home');
                        }else{
                            let error = response.data.error;
                            let x= Object.values(error);
                            // console.log(`x: ${x}`);
                            this.errors.push(x);
                            // console.log(error);
                            this.$swal({
                                position: 'top-end',
                                icon: 'error',
                                title: this.errors.toString(),
                                showConfirmButton: false,
                                timer: 1500
                            });
                            // this.$swal();
                            // this.errors = [];
                            // this.errors.push(response.data.message);
                            // console.log(this.errors);
                        }

                    });
                }else{

                    if(this.reqbody.password.length <= 6){
                        this.errors.push('Password length must be more than 6');
                    }
                    if(this.reqbody.password_confirmation !== this.reqbody.password){
                        this.errors.push('Passwords do not match');
                    }
                    // alert(`These fields must be filled: ${this.errors.toString()}`);
                    // this.$swal(`These fields must be filled: ${this.errors.toString()}`);
                    this.$swal({
                                // position: 'top-end',
                                // icon: 'error',
                                // toast: true,
                                title: this.errors.toString(),
                                // showConfirmButton: false,
                                // timer: 1500

                                toast: true,
                                position: 'top-end',
                                // title: response.data.message,
                                showConfirmButton: false,
                                timer: 3000
                            });
                    e.preventDefault();
                }
            }

        }
    }
</script>
